import React from 'react';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import mapValues from 'lodash/mapValues';
import memoize from 'lodash/memoize';

import { modalShow } from 'store/actions';
import { fromReservation } from 'store/selectors';
import { ColumnWidth } from 'domain/columnWidth';

import { DepartureGuestList } from 'components';

const row1 = {
  number: ColumnWidth.Number,
  firstName: ColumnWidth.FirstName,
  lastName: ColumnWidth.LastName,
  gender: ColumnWidth.Gender,
  age: ColumnWidth.Age,
  birthday: ColumnWidth.Birthday,
  nationality: ColumnWidth.Nationality,
  expand: ColumnWidth.Expand,
  cabin: ColumnWidth.Cabin,
};
const row2 = {
  space: ['number'],
  email: ['firstName', 'lastName'],
  specialNeeds: ['birthday', 'gender'],
  extra: ['age', 'nationality'],
  icePhoneNumber: ['expand', 'cabin'],
};
const row3 = {
  space: ['number'],
  documentType: ['firstName', 'lastName'],
  documentNumber: ['gender', 'age'],
  documentIssuingCountry: ['age', 'expand'],
  documentExpiryDate: ['gender', 'age'],
};
const vehicleRow = {
  vehicleType: ['firstName', 'lastName', 'birthday'],
  registrationNumber: ['gender', 'age'],
  trailer: ['nationality', 'expand', 'cabin'],
};

const sum = row => Object.keys(row).reduce((sum, col) => sum + row[col], 0);
const divideRow = row => mapValues(row, val => val / sum(row));
const modify = (row, modifiers) => ({ ...row, ...modifiers });
const calculateWidthsFromRow = (ref, row) => mapValues(row, keys => keys.reduce((sum, col) => sum + ref[col], 0));

const memoizedColumnWidths = memoize((isBirthDateMandatory, hasCabins, collectIcePhoneNumber) => {
  const modifiers = {};
  if (!isBirthDateMandatory) {
    modifiers.birthday = 0;
  }
  if (!hasCabins && !collectIcePhoneNumber) {
    modifiers.cabin = 0;
  }

  const adjustedRow = divideRow(modify(row1, modifiers));
  const adjustedRow2 = calculateWidthsFromRow(adjustedRow, row2);
  const adjustedRow3 = calculateWidthsFromRow(adjustedRow, row3);
  const adjustedVehicleRow = calculateWidthsFromRow(adjustedRow, vehicleRow);

  return {
    ...adjustedRow,
    ...adjustedRow2,
    ...adjustedRow3,
    ...adjustedVehicleRow,
  };
}, (...args) => args.join(''));

const getColumnWidths = createSelector(
  state => state,
  fromReservation.isBirthDateMandatory,
  fromReservation.getActiveDepartureId,
  (state, isBirthDateMandatory, departureId) => {
    const hasCabins = fromReservation.getCabinsByDeparture(state, departureId).length > 0;
    const collectIcePhoneNumber = fromReservation.collectIcePhoneNumber(state, departureId);

    return memoizedColumnWidths(isBirthDateMandatory, hasCabins, collectIcePhoneNumber);
  },
);

const DepartureGuestListContainer = props => <DepartureGuestList {...props} />;

const mapStateToProps = (state, { id }) => ({
  active: fromReservation.getActiveDepartureId(state) === id,
  departure: fromReservation.getDeparture(state, id),
  widths: getColumnWidths(state),
  collectIcePhoneNumber: fromReservation.collectIcePhoneNumber(state, id),
  collectLoyaltyNumber: fromReservation.collectLoyaltyNumber(state, id),
});

const mapDispatchToProps = (dispatch, { id }) => ({
  onManageAll: () => dispatch(modalShow(`selectCabin-${id}`)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DepartureGuestListContainer);



// WEBPACK FOOTER //
// ./src/containers/DepartureGuestList.js